import * as actions from "./actions";

let initialState = {
  smsTemplates: {
    fetching: false,
    fetched: false,
    data: [],
  },
};

const terms = (state = initialState, action) => {
  switch (action.type) {
    //Borrower terms
    case actions.SMS_TEMPLATES_GET_SUCCESS:
      return Object.assign({}, state, {
        smsTemplates: Object.assign({}, state.smsTemplates, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });
    case actions.SMS_TEMPLATES_GET_REQUEST:
      return Object.assign({}, state, {
        smsTemplates: Object.assign({}, state.smsTemplates, {
          fetching: true,
        }),
      });
    default:
      return state;
  }
};

export default terms;
